import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {Range} from "../../../../shared/model/range-model";
import {CommonModalComponent} from "../../../../shared/common-modal/common-modal.component";
import {TranslateService} from "@ngx-translate/core";
import {MessageService} from "primeng/api";
import {OfferDataManagementService} from "../../offer-data-management.service";
import {CustomTranslateLoader} from "../../../../shared/localization/CustomTranslateLoader";
import {TranslationService} from "../../../shared";
import {SessionStorage} from "ngx-webstorage";
import {User} from "../../../../shared/user/user";

@Component({
  standalone: false,
  selector: 'app-odm-add-accessories-modal',
  templateUrl: './odm-add-accessories-modal.component.html',
  styleUrls: ['./odm-add-accessories-modal.component.less']
})
export class OdmAddAccessoriesModalComponent {

  @ViewChild('addAccessoriesRangeModal', {static: false}) addAccessoriesRangeModal: CommonModalComponent;

  @Input()
  selectedRange: Range;

  @SessionStorage()
  public user: User;

  @Input() ranges!: Range[];
  rangeName: string = '';
  rangeNames: any = {};
  languages: any;

  @Output() rangeCreated = new EventEmitter<Range>();
  constructor(private translateService: TranslateService,
              private translationService: TranslationService,
              private readonly offerDataManagementService: OfferDataManagementService,
              private customTranslateLoader: CustomTranslateLoader,
              private readonly messageService: MessageService) {
  }

  hide() {
    this.addAccessoriesRangeModal.hide();
  }
  cancel() {
    this.rangeName = '';
    this.hide();
  }
  /**
   * Function to check if the form is valid
   * It is valid if the accessories' range selected if unique
   */

  public isValidForm(): boolean {
    if (!this.languages?.length) return false;

    // All fields must be non-empty and valid
    return this.languages.every((lang: string | number) => {
      const value = this.rangeNames[lang];
      return value && value.trim() !== '' && !/[\\/]/.test(value);
    });
  }
  /**
   * Function to create a new accessories' range with the given name
   * @param rangeNames
   */
  createAccessoryRange(rangeNames: any): void {
    this.offerDataManagementService.createAccessoryRange(rangeNames).subscribe({
      next: (range) => {
        this.refreshTranslations();
        this.selectedRange = range;
        this.showSuccessMessage("T_ACCESSORIES_RANGE_SUCCESS_TITLE");
        this.rangeCreated.emit(range);
      },
      error: () => {
        this.showErrorMessage("T_ACCESSORIES_RANGE_ERROR_TITLE");
      }
    });
  }
  /**
   * Refresh translations to get the new range name in the current language
   * @private
   */
  private refreshTranslations(): void {
    this.customTranslateLoader.getLastTranslation(this.translateService.currentLang).subscribe(res => {
        this.translateService.setTranslation(this.translateService.currentLang, res,true);
      });
  }
  /**
   * Function to show the modal to create a new accessories' range
   */
  showAccessoryRangeModal() {
    this.rangeNames = {};
    this.translationService
      .getAllLanguagesByCountry(this.user.partnerCountry)
      .subscribe(langList => {
        this.languages = [...langList];
        this.languages.forEach(lang => {
          this.rangeNames[lang] = '';
        });
        this.addAccessoriesRangeModal.show();
      });
  }
  /**
   * Function to check if the accessories' range name contains invalid characters
   * @param value
   */
  public containsInvalidAccessoryRangeCharacters(value: string): boolean {
    return /[\\/]/.test(value);
  }
  /**
   * Function to show an error message with the given message key
   * @param messageKey
   * @private
   */
  private showErrorMessage(messageKey: string): { severity: string; summary: string; detail: string } {
    const message = {
      severity: 'error',
      summary: this.translateService.instant('T_ERROR'),
      detail: this.translateService.instant(messageKey),
    };
    this.messageService.add(message);
    return message;
  }
  /**
   * Function to show a success message with the given message key
   * @param messageKey
   * @private
   */
  private showSuccessMessage(messageKey: string): { severity: string; summary: string; detail: string } {
    const message = {
      severity: 'success',
      summary: this.translateService.instant('T_SUCCESS'),
      detail: this.translateService.instant(messageKey),
    };
    this.messageService.add(message);
    return message;
  }
}
